import Link from 'next/link'
import React from 'react'
import { TLinkedProgram } from '~shared/api/single-program-data/types'
import { Button } from '~shared/components/button-v2'
import { cn } from '~shared/utils/cn'
import { programLink } from '~shared/utils/program-link'
import { LeadFormDialog } from '~widgets/lead-form/components/lead-form-dialog'

export const ProgramArchiveCard = ({
  program
}: {
  program: TLinkedProgram
}) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const formats = [
    {
      key: 'price',
      price: program?.costOnline?.priceOnline,
      studyDurationYears: program?.costOnline?.studyDurationYearsOnline,
      studyDurationMonths: program?.costOnline?.studyDurationMonthsOnline,
      studyHours: program?.costOnline?.studyHoursOnline
    },
    {
      key: 'priceMixed',
      price: program?.cost?.price,
      studyDurationYears: program?.cost?.studyDurationYears,
      studyDurationMonths: program?.cost?.studyDurationMonths,
      studyHours: program?.cost?.studyHours
    },
    {
      key: 'priceOffline',
      price: program?.costOffline?.priceOffline,
      studyDurationYears: program?.costOffline?.studyDurationYearsOffline,
      studyDurationMonths: program?.costOffline?.studyDurationMonthsOffline,
      studyHours: program?.costOffline?.studyHoursOffline
    }
  ].filter(format => format.price !== null && format.price !== undefined)
  return (
    <div className='bg-[#F2F2F2] h-[400px] rounded-[16px] overflow-hidden relative'>
      <div className='p-[24px]'>
        <div className='flex'>
          <span
            className='px-[10px] py-[4px] md:py-[8px] flex items-center max-w-[190px] rounded-[24px]'
            style={
              program?.faculty?.color
                ? {
                    backgroundColor: `${program.faculty?.color}30`,
                    color: program.faculty?.color
                  }
                : {}
            }>
            {program?.faculty?.name}
          </span>
          <span className='bg-white px-[10px] flex items-center rounded-[24px] h-[27px] md:h-[37px]'>
            {program?.category?.name}
          </span>
        </div>
        <p className='text-[24px] font-medium mt-[24px] line-clamp-1'>
          {program?.name}
        </p>
        <p className='text-[#8B8B8B] leading-[120%] mt-[8px] mb-[24px] line-clamp-3'>
          {program?.description}
        </p>
        <p className='text-[14px] text-[#8B8B8B]'>
          {Number(formats[0]?.studyDurationYears) > 0 && (
            <span>{formats[0]?.studyDurationYears} год </span>
          )}
          {Number(formats[0]?.studyDurationYears) > 0 &&
            Number(formats[0]?.studyDurationMonths) > 0 && <span>/ </span>}
          {Number(formats[0]?.studyDurationMonths) > 0 && (
            <span>{formats[0]?.studyDurationMonths} мес </span>
          )}
          {Number(formats[0]?.studyHours) > 0 && (
            <span>/ {formats[0]?.studyHours} часов </span>
          )}
        </p>
      </div>
      <img
        src={program?.image?.url ?? ''}
        alt={program?.image?.alternativeText ?? ''}
        className='object-center rounded-[16px] w-full h-[208px] object-cover'
      />
      <div className='grid grid-cols-2 gap-[8px] absolute bottom-[24px]  px-[24px] w-full'>
        <Link
          prefetch={false}
          href={programLink(program)}
          className={cn(
            'rounded-[16px] justify-center bg-[#EBEEFD] duration-200 ease-in-out text-accent flex items-center h-[50px]',
            'hover:bg-white hover:text-black'
          )}>
          Подробнее
        </Link>
        <Button
          onClick={() => setIsOpen(true)}
          className='rounded-[16px] duration-200 ease-in-out justify-center bg-accent text-white flex items-center h-[50px] hover:bg-black'>
          Записаться
        </Button>
        <LeadFormDialog
          open={isOpen}
          onOpenChange={setIsOpen}
          program={{
            productId: program?.productUid ?? null,
            productName: program?.name ?? '',
            productCategory: program?.category?.name ?? '',
            productFaculty: program?.faculty?.name ?? ''
          }}
        />
      </div>
    </div>
  )
}
